import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import { recordServerLogoutThenClearHotSession } from "@/utils/hotSessionClear";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
import BostonLayout from "@/views/Pages/BostonLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";
import Price from "../views/Super/Price.vue";
import Account_type from "../views/Super/account_type.vue";
import ChurchLogin from "../views/Pages/ChurchLogin.vue";
import ChurchForget from "../views/Pages/ChurchForget.vue";

//  admin
const Marketing = () => import(/* webpackChunkName: "marketing" */ '@/views/Super/Marketing.vue');
const EmailMarketingTemplate = () => import(/* webpackChunkName: "marketing" */ '@/views/Super/EmailMarketingTemplate.vue');
const CreateEmailTemplate = () => import(/* webpackChunkName: "marketing" */ '@/views/Super/CreateEmailTemplate.vue');
const AllCompanies = () =>
  import(/* webpackChunkName: "company" */ "@/views/Super/AllCompanies.vue");
const EditCompany = () =>
  import(/* webpackChunkName: "company" */ "@/views/Super/EditCompany.vue");
const Certificates = () =>
  import(/* webpackChunkName: "cert" */ "@/views/Super/Certificates.vue");
const Account = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Super/Account.vue");
const EmailAccounts = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Super/EmailAccounts.vue");
const TutorialVideo = () =>
  import(/* webpackChunkName: "tutorial" */ "@/views/Super/TutorialVideo.vue");
const TourPage = () =>
  import(/* webpackChunkName: "tutorial" */ "@/views/Super/TourPage.vue");
const AlertsManager = () => import(/* webpackChunkName: "alerts" */ '@/views/Super/AlertsManager.vue');

const UserAgreementManager = () => import( '@/views/Super/UserAgreementManager.vue');

const AllNotifications = () =>
  import(/* webpackChunkName: "tutorial" */ "@/views/Super/Notifications.vue");
const AddTutorialVideo = () =>
  import(
    /* webpackChunkName: "tutorial" */ "@/views/Super/AddTutorialVideo.vue"
  );
const AddTourVideo = () =>
  import(/* webpackChunkName: "tutorial" */ "@/views/Super/AddTourVideo.vue");
const AddNewNotification = () =>
  import(/* webpackChunkName: "tutorial" */ "@/views/Super/AddNewNotification.vue");
const CreateCertificate = () =>
  import(/* webpackChunkName: "cert" */ "@/views/Super/CreateCertificate.vue");
const Courses = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/Courses.vue");
const CreateCourse = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/CreateCourse.vue");
const CourseFolder = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/CourseFolder.vue");
const CourseFolderDetails = () =>
  import(
    /* webpackChunkName: "course" */ "@/views/Super/CourseFolderDetails.vue"
  );
const CreateCourseFolder = () =>
  import(
    /* webpackChunkName: "course" */ "@/views/Super/CreateCourseFolder.vue"
  ); const UserActivityHistoryReport = () => import(/* webpackChunkName: "UserActivityReportResources" */ '@/views/Super/UserActivityHistoryReport.vue');
const CertificateDetails = () =>
  import(/* webpackChunkName: "cert" */ "@/views/Super/CertificateDetails.vue");
const CreateCompany = () =>
  import(/* webpackChunkName: "company" */ "@/views/Super/CreateCompany.vue");
const AllUsers = () =>
  import(/* webpackChunkName: "user" */ "@/views/Super/AllUsers.vue");
const CompanyLocations = () =>
  import(
    /* webpackChunkName: "location" */ "@/views/Super/CompanyLocations.vue"
  );
const AddLocation = () =>
  import(/* webpackChunkName: "location" */ "@/views/Super/AddLocation.vue");
const CompanyCertificates = () =>
  import(
    /* webpackChunkName: "cert" */ "@/views/Super/CompanyCertificates.vue"
  );
const CompanyCourses = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/CompanyCourses.vue");
const CompanyCourseFolders = () =>
  import("@/views/Super/CompanyCourseFolders.vue");
const LocationDetails = () =>
  import(
    /* webpackChunkName: "location" */ "@/views/Super/LocationDetails.vue"
  );
const CourseCatalog = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/CourseCatalog.vue");
const CompanyCourseDetails = () =>
  import(
    /* webpackChunkName: "company" */ "@/views/Super/CompanyCourseDetails.vue"
  );
const CourseInstructions = () =>
  import(
    /* webpackChunkName: "course" */ "@/views/Super/CourseInstructions.vue"
  );
const LessonForm = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/LessonForm.vue");
const LessonFormNew = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/LessonFormNew.vue");
const LessonFormMob = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/LessonFormMobile.vue");
const WorkDayLesson = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/WorkDayLesson.vue");
const EditCourse = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/EditCourse.vue");
const EmployeeCertificates = () =>
  import(
    /* webpackChunkName: "cert" */ "@/views/Super/EmployeeCertificates.vue"
  );
const EmployeeResources = () =>
  import(
    /* webpackChunkName: "resource" */ "@/views/Super/EmployeeResources.vue"
  );
const EmployeeDocuments = () =>
  import(
    /* webpackChunkName: "resource" */ "@/views/Super/EmployeeDocuments.vue"
  );
const EmployeeCourses = () =>
  import(/* webpackChunkName: "course" */ "@/views/Super/EmployeeCourses.vue");
const EmployeeCoursePurchase = () =>
  import(
    /* webpackChunkName: "course" */ "@/views/Super/EmployeeCoursePurchase.vue"
  );
const AddEmployee = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Super/AddEmployee.vue");
const CreateUser = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Pages/CreateUser.vue");

const CompanyEmployees = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/CompanyEmployees.vue"
  );
const Resources = () =>
  import(/* webpackChunkName: "mainResources" */ "@/views/Super/Resources.vue");
const ResourcesNew = () =>
  import(/* webpackChunkName: "resources" */ "@/views/Super/ResourcesNew.vue");
const LoginReport = () =>
  import(/* webpackChunkName: "LoginResource" */ "@/views/Super/LoginReport.vue");
const ActivityReport = () =>
  import(
    /* webpackChunkName: "ActivityResources" */ "@/views/Super/ActivityReport.vue"
  );
const CourseFailPassReport = () =>
  import(
    /* webpackChunkName: "CourseResources" */ "@/views/Super/CourseFailPassReport.vue"
  );
// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
// Notification pages
const Notification = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Notification.vue");
// Pages
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");

const BostonLogin = () =>
  import(/* webpackChunkName: "Bostonpages" */ "@/views/Pages/BostonLogin.vue");
const BostonForgetPassword = () =>
  import(/* webpackChunkName: "Bostonpages" */ "@/views/Pages/BostonForgetPassword.vue");
const Home = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const Tour = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Tour.vue");

const Shift4LinkInstall = () =>
  import(/* webpackChunkName: "shift4" */ "@/views/Pages/Shift4LinkInstall.vue")

const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const RegisterMinLocation = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Pages/RegisterMinLocation.vue"
  );
const UserRegister = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserRegister.vue");
const BostonUserRegister = () =>
  import(/* webpackChunkName: "Bostonpages" */ "@/views/Pages/BostonUserRegister.vue");
const Signup = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Signup.vue");
const Boston = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/BostonPage.vue");
const ForgetPassword = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Super/ForgetPassword.vue");

const ResetPassword = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Super/ResetPassword.vue");
const SafeDigResetPassword = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/safe-dig-indiana/SafeDigResetPassword.vue");
const TestQuestionReport = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/TestQuestionReport.vue"
  );
const SurveyReport = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Super/SurveyReport.vue");
const SurveySubmissions = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/SurveySubmissions.vue"
  );
const SurveySubmissionsDetail = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/SurveySubmissionsDetail.vue"
  );
const UserOnboardingReport = () =>
  import(
    /* webpackChunkName: "Onboardingresources" */ "@/views/Super/UserOnboardingReport.vue"
  );
const AllOnboardingReport = () =>
  import(
    /* webpackChunkName: "Onboardingresources" */ "@/views/Super/AllOnboardingReport.vue"
  );
const HrFormReport = () =>
  import(/* webpackChunkName: "resources" */ "@/views/Super/HrFormReport.vue");
//sub-admin
const CreateSubAdmin = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Super/CreateSubAdmin.vue");
// Promo code
const PromoCodes = () =>
  import(/* webpackChunkName: "employee" */ "@/views/Super/PromoCodes.vue");
const CreatePromoCodes = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/CreatePromoCodes.vue"
  );
const PromoCodeReport = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/PromoCodeReport.vue"
  );
const LeadsList = () =>
  import(
    /* webpackChunkName: "employee" */ "@/views/Super/LeadsList.vue"
  );

const AddOns = () =>
  import(/* webpackChunkName: "addons" */ "@/views/Super/AllAddons.vue");
const CreateAddOns = () =>
  import(/* webpackChunkName: "addons" */ "@/views/Super/CreateAddons.vue");
const ScormReport = () =>
  import(/* webpackChunkName: "ScormResources" */ "@/views/Super/ScormReport.vue");
const ScormReportDetails = () =>
  import(
    /* webpackChunkName: "ScormResourcesDetails" */ "@/views/Super/ScormReportDetails.vue"
  );

const HospitalityInsurance = () =>
  import(
    /* webpackChunkName: "resources" */ "@/views/Super/HospitalityInsurance.vue"
  );
const NewSignUp = () =>
  import(
    /* webpackChunkName: "resources" */ "@/views/Super/NewSignUp.vue"
  );

const CourseSelection = () =>
  import(
    /* webpackChunkName: "resources" */ "@/views/Super/CourseSelection.vue"
  );
const Pricing = () =>
  import(
    /* webpackChunkName: "resources" */ "@/views/Super/NewPricePage.vue"
  );

const NewSignUp1 = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/NewSignUp1.vue");
const NewUserRegister = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/NewUserRegister.vue");
const NewUserRegisterND = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserRegistrationND.vue");
const UserRegister2 = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserRegister2.vue");
const NewRegisterPage = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/NewSignupPage.vue");
const NewCompanyRegister = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/NewRegister.vue");
const NewCompanyRegister2 = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/CompanyNewRegistration.vue");
let bostonLayout = {
  path: "/",
  component: BostonLayout,
  name: "Boston",
  children: [

    {
      path: "/boston_user_register",
      name: "Boston User Register",
      component: BostonUserRegister,
      meta: {
        title: "Boston-User-Register",
        noBodyBackground: true,
      },
    },

  ]
}
let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        noBodyBackground: true,
      },
    },



    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        title: "Register",
        noBodyBackground: true,
        requiresGuest: true,

      },
    },
    {
      path: "/register_1-3_locations",
      name: "RegisterMinLocation",
      component: RegisterMinLocation,
      meta: {
        noBodyBackground: true,
      },
    },
    {
      path: "/user_register",
      name: "User Register",
      component: UserRegister,
      meta: {
        title: "User-Register",
        noBodyBackground: true,
      },
    },
    {
      path: "/signup",
      name: "Sign Up",
      component: Signup,
      meta: {
        title: "Sign-Up",
        noBodyBackground: true,
        requiresGuest: true,

      },
    },
    {
      path: "/hig/:companyName?",
      name: "HospitalityInsurance",
      component: HospitalityInsurance,
    },
    // {
    //   path: "/new-signUp",
    //   name: "NewSignUp",
    //   component: NewSignUp,
    // },
    {
      path: "/hig/:companyName/course_selection",
      name: "CourseSelection",
      component: CourseSelection,
    },
    // {
    //   path: "/new-price",
    //   name: "Pricing",
    //   component: Pricing,
    // },
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
    },
  ],
};


const routes = [
  {
    path: "/boston-college",
    name: "BostonPage",
    component: Boston,
    meta: {
      title: "Boston",
      noBodyBackground: true,
      requiresGuest: true,

    },
  },
  { path: '/company/:slug', name: 'BrandLogin', component: () => import('@/views/company/BrandLogin.vue'), props: true },

  {
    path: "/boston_login",
    name: "Boston Login",
    component: BostonLogin,
    meta: {
      noBodyBackground: true,
      requiresGuest: true,
    },
  },
  {
    path: "/boston_forget_password",
    name: "Boston Forget Login",
    component: BostonForgetPassword,
    meta: {
      noBodyBackground: true,
      requiresGuest: true,
    },
  },
  {
    path: "/church_login",
    name: "Church Login",
    component: ChurchLogin,
    meta: {
      noBodyBackground: true,
      requiresGuest: true,
    },
  },
  {
    path: "/church_forget_password",
    name: "Church Forget Login",
    component: ChurchForget,
    meta: {
      noBodyBackground: true,
      requiresGuest: true,
    },
  },

  {
    path: "/lesson_form_mob",
    name: "LessonForm2",
    component: LessonFormMob,
  },
  {
    path: "/workday_lesson",
    name: "LessonForm2",
    component: WorkDayLesson,
  },
  {
    path: "/forget_password",
    name: "ForgetPassword",
    component: ForgetPassword,
    meta: {
      noBodyBackground: true,
      requiresGuest: true,
    },
  },

  {
    path: "/reset_password",
    name: "ResetPassword",
    component: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig"
      ? SafeDigResetPassword
      : ResetPassword,
    meta: {
      title: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig" ? "Reset Password | Safe Dig Indiana" : "Reset-Password",
      noBodyBackground: true,
      requiresGuest: true,

    },
  },
  {
    path: "/price",
    name: "Price",
    component: Price,
    meta: {
      noBodyBackground: true,
    },
  },
  {
    path: "/account_type",
    name: "AccountType",
    component: Account_type,
    meta: {
      noBodyBackground: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig"
      ? () => import("@/views/Pages/safe-dig-indiana/SafeDigLogin.vue")
      : Login,
    meta: {
      title: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig" ? "Log In | Safe Dig Indiana" : undefined,
      noBodyBackground: true,
      requiresGuest: true,
    },
  },
  {
    path: "/certificate-access",
    name: "CertificateAccess",
    component: () => import("@/views/Pages/CertificateAccess.vue"),
    meta: {
      noBodyBackground: true,
      title: "Certificate",
    },
  },
  {
    path: "/shift4/link/install",
    name: "shift4-link-install",
    component: Shift4LinkInstall,
    meta: {
      noBodyBackground: true,
    },
  },
  {
    path: "/tour",
    name: "Tour",
    component: Tour,
    meta: {
      noBodyBackground: true,
    },
  },
  {
    path: "/new_registration",
    name: "New User SignUp",
    component: UserRegister2,
    meta: {
      title: "User-Signup",
      noBodyBackground: true,
    },
  },
   {
    path: "/new_sign_up",
    name: "New SignUp",
    component: NewSignUp1,
    meta: {
      title: "New Sign up",
      noBodyBackground: true,
    },
  },
  {
    path: "/new-user_register",
    name: "New User Register",
    component: NewUserRegisterND,
    meta: {
      title: "User-Register",
      noBodyBackground: true,
    },
  },
  {
    path: "/company_register",
    name: "New Company Register",
    component: NewCompanyRegister2,
    meta: {
      // title: "User-Register",
      noBodyBackground: true,
    },
  },
  {
    path: "/user_register2",
    name: "New User Register",
    component: UserRegister2,
    meta: {
      title: "User-Register",
      noBodyBackground: true,
    },
  },
  {
    path: "/new_user_register_nd",
    name: "New User Register ND",
    component: NewUserRegisterND,
    meta: {
      title: "User-Register",
      noBodyBackground: true,
    },
  },

  {
    path: "/company_register_nd",
    name: "New Company Register",
    component: NewCompanyRegister2,
    meta: {
      // title: "Company Register",
      noBodyBackground: true,
    },
  },
  {
    path: "/concord-hospitality",
    name: "concord-hospitality",
    component: () => import("@/concord-hospitality/SignUpPage.vue"),
  },
  {
    path: "/home",
    name: "SafeDigIndiana",
    component: () => import("@/views/Pages/safe-dig-indiana/SafeDigIndianaPage.vue"),
    meta: {
      title: "Safe Dig Indiana",
      noBodyBackground: true,
    },
  },
  {
    path: "/professionals",
    name: "SafeDigProfessional",
    component: () => import("@/views/Pages/safe-dig-indiana/SafeDigProfessional.vue"),
    meta: {
      title: "Safe Dig Indiana - Professionals",
      noBodyBackground: true,
    },
  },
  {
    path: "/homeowners",
    name: "SafeDigHomeOwner",
    component: () => import("@/views/Pages/safe-dig-indiana/SafeDigHomeOwner.vue"),
    meta: {
      title: "Safe Dig Indiana - Homeowners",
      noBodyBackground: true,
    },
  },
  // Redirect old Safe Dig auth paths to unified /login, /register, /forgot_password
  ...(process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig"
    ? [
        { path: "/safe-dig-indiana/login", redirect: "/login" },
        { path: "/safe-dig-indiana/register", redirect: "/register" },
        { path: "/safe-dig-indiana/forgot_password", redirect: "/forgot_password" },
        { path: "/safe-dig-indiana/reset_password", redirect: "/reset_password" },
        {
          path: "/safe-dig-indiana",
          beforeEnter(to, from, next) {
            recordServerLogoutThenClearHotSession().then(() => {
              next({ path: "/home", replace: true });
            });
          }
        }
      ]
    : []),
  // Safe Dig: /register and /forgot_password use same paths as HomeOfTraining
  {
    path: "/register",
    name: "SafeDigRegister",
    component: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig"
      ? () => import("@/views/Pages/safe-dig-indiana/SafeDigRegister.vue")
      : Register,
    meta: {
      title: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig" ? "Create Account | Safe Dig Indiana" : "Register",
      noBodyBackground: true,
      requiresGuest: true,
    },
  },
  {
    path: "/forgot_password",
    name: "SafeDigForgotPassword",
    component: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig"
      ? () => import("@/views/Pages/safe-dig-indiana/SafeDigForgotPassword.vue")
      : () => import("@/views/Super/ForgetPassword.vue"),
    meta: {
      title: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig" ? "Account Lookup | Safe Dig Indiana" : "Forget Password",
      noBodyBackground: true,
    },
  },
  {
    path: "/info",
    component: () => import("@/views/Pages/safe-dig-indiana/SafeDigInfoLayout.vue"),
    meta: { title: "Safe Dig Indiana - Info", noBodyBackground: true },
    redirect: "/info/contact_us",
    children: [
      {
        path: "contact_us",
        name: "SafeDigContactUs",
        component: () => import("@/views/Pages/safe-dig-indiana/SafeDigContactUs.vue"),
      },
      {
        path: "whats_new",
        name: "SafeDigWhatsNew",
        component: () => import("@/views/Pages/safe-dig-indiana/SafeDigWhatsNew.vue"),
      },
      {
        path: "community",
        name: "SafeDigCommunity",
        component: () => import("@/views/Pages/safe-dig-indiana/SafeDigCommunity.vue"),
      },
      {
        path: "events",
        name: "SafeDigEvents",
        component: () => import("@/views/Pages/safe-dig-indiana/SafeDigEvents.vue"),
      },
      {
        path: "grants",
        name: "SafeDigGrants",
        component: () => import("@/views/Pages/safe-dig-indiana/SafeDigGrants.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig" ? "/home" : "/login",
    name: "Login",
  },
  {
    path: "/payment-information",
    name: "EmailAccounts",
    component: EmailAccounts,
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "notification",
        name: "Notification",
        component: Notification,
      },
      {
        path: "all_companies",
        name: "All Companies",
        component: AllCompanies,
      },
      {
        path: "edit_company",
        name: "Edit Company",
        component: EditCompany,
      },
      {
        path: "certificates",
        name: "Certificates",
        component: Certificates,
      },
      {
        path: "courses",
        name: "Courses",
        component: Courses,
      },
      {
        path: "create_course",
        name: "CreateCourse",
        component: CreateCourse,
      },
      {
        path: "course_folder",
        name: "CourseFolder",
        component: CourseFolder,
      },
      {
        path: "course_folder_details",
        name: "CourseFolderDetails",
        component: CourseFolderDetails,
      },
      {
        path: "create_course_folder",
        name: "CreateCourseFolder",
        component: CreateCourseFolder,
      },
      {
        path: "certificate_details",
        name: "CertificateDetails",
        component: CertificateDetails,
      },
      {
        path: "create_company",
        name: "CreateCompany",
        component: CreateCompany,
      },
      {
        path: "test_question_report",
        name: "TestQuestionReport",
        component: TestQuestionReport,
      },
      {
        path: "survey_report",
        name: "SurveyReport",
        component: SurveyReport,
      },
      {
        path: "survey_submissions",
        name: "SurveySubmissions",
        component: SurveySubmissions,
      },
      {
        path: "survey_submissions_detail",
        name: "SurveySubmissionsDetail",
        component: SurveySubmissionsDetail,
      },
      {
        path: "account",
        name: "Account",
        component: Account,
      },
      {
        path: '/marketing',
        name: 'marketing',
        component: Marketing
      },
      {
        path: '/email_template',
        name: 'emailTemplate',
        component: EmailMarketingTemplate
      },
      {
        path: '/create_email_template',
        name: 'emailTemplate',
        component: CreateEmailTemplate
      },
      {
        path: "tutorial_video",
        name: "TutorialVideo",
        component: TutorialVideo,
      },
      {
        path: "tour_page",
        name: "TourPage",
        component: TourPage,
      },
      {
        path: "all_notifications",
        name: "Notifications",
        component: AllNotifications,
      },
      {
        path: "add_tutorial_video",
        name: "AddTutorialVideo",
        component: AddTutorialVideo,
      },
      {
        path: "add_tour_video",
        name: "AddTourVideo",
        component: AddTourVideo,
      },
      	{
				path: 'alerts_manager',
				name: 'AlertsManager',
				component: AlertsManager
			},
      	{
				path: 'user-agreement-manager',
				name: 'UserAgreementManager',
				component: UserAgreementManager
			},
      {
        path: "add_new_notification",
        name: "AddNewNotification",
        component: AddNewNotification,
      },
      {
        path: "create_certificate",
        name: "CreateCertificate",
        component: CreateCertificate,
      },
      {
        path: "all_users",
        name: "All Users",
        component: AllUsers,
      },
      {
        path: "create_user",
        name: "Create Users",
        component: CreateUser,
      },
      {
        path: "company_locations",
        name: "ComapanyLocations",
        component: CompanyLocations,
      },
      {
        path: "add_location",
        name: "AddLocation",
        component: AddLocation,
      },
      {
        path: "company_certificates",
        name: "CompanyCertificates",
        component: CompanyCertificates,
      },
      {
        path: "company_courses",
        name: "CompanyCourses",
        component: CompanyCourses,
      },
      {
        path: "location_details",
        name: "LocationDetails",
        component: LocationDetails,
      },
      {
        path: "company_coursefolders",
        name: "CompanyCourseFolders",
        component: CompanyCourseFolders,
      },
      {
        path: "course_catalog",
        name: "CourseCatalog",
        component: CourseCatalog,
      },
      {
        path: "company_course_details",
        name: "CompanyCourseDetails",
        component: CompanyCourseDetails,
      },
      {
        path: "course_instructions",
        name: "CourseInstructions",
        component: CourseInstructions,
      },
      {
        path: "lesson_form_old",
        name: "LessonForm",
        component: LessonForm,
      },
      {
        path: "lesson_form",
        name: "LessonFormNew",
        component: LessonFormNew,
      },
      {
        path: "lesson_form_new",
        name: "LessonFormNew",
        component: LessonFormNew,
      },
      {
        path: "edit_course",
        name: "EditCourse",
        component: EditCourse,
      },
      {
        path: "employee_certificates",
        name: "EmployeeCertificates",
        component: EmployeeCertificates,
      },
      {
        path: "employee_resources",
        name: "EmployeeResources",
        component: EmployeeResources,
      },
      {
        path: "employee_documents",
        name: "EmployeeDocuments",
        component: EmployeeDocuments,
      },

      {
        path: "employee_courses",
        name: "EmployeeCourses",
        component: EmployeeCourses,
      },
      {
        path: "employee_course_purchase",
        name: "EmployeeCoursePurchase",
        component: EmployeeCoursePurchase,
      },
      {
        path: "/add_employee",
        name: "AddEmployee",
        component: AddEmployee,
      },
      {
        path: "/resources_new",
        name: "Resources",
        component: ResourcesNew,
      },
      {
        path: "/company_employees",
        name: "CompanyEmployees",
        component: CompanyEmployees,
      },
      {
        path: "/resources",
        name: "Resources",
        component: Resources,
      },

      {
        path: "/login_report",
        name: "LoginReport",
        component: LoginReport,
      },
      {
        path: '/user_activity_history',
        name: 'UserActivityHistory',
        component: UserActivityHistoryReport
      },
      {
        path: "/activity_report",
        name: "ActivityReport",
        component: ActivityReport,
      },
      {
        path: "/documents-report",
        name: "Documents Report",
        component: () => import("@/views/Common/DocumentsReport.vue"),
      },
      {
        path: "/course_fail_pass_report",
        name: "CourseFailPassReport",
        component: CourseFailPassReport,
      },
      {
        path: "/onboarding_report",
        name: "OnboardingReport",
        component: UserOnboardingReport,
      },
      {
        path: "/all_onboarding_report",
        name: "AllOnboardingReport",
        component: AllOnboardingReport,
      },
      {
        path: "/hrform_report",
        name: "HrFromReport",
        component: HrFormReport,
      },
      {
        path: "/create_subadmin",
        name: "CreateSubAdmin",
        component: CreateSubAdmin,
      },
      {
        path: "/promo_codes",
        name: "PromoCodes",
        component: PromoCodes,
      },
      {
        path: "/create_promo_code",
        name: "CreatePromoCodes",
        component: CreatePromoCodes,
      },
      {
        path: "/promo_code_report",
        name: "PromoCodeReport",
        component: PromoCodeReport,
      },
      {
        path: "/leads",
        name: "LeadsList",
        component: LeadsList,
      },
      {
        path: "/abandon_carts",
        name: "AbandonCarts",
        component: LeadsList,
        meta: { filterAbandoned: true },
      },
      {
        path: "/addons",
        name: "Addons",
        component: AddOns,
      },
      {
        path: "/create_addons",
        name: "CreateAddons",
        component: CreateAddOns,
      },
      {
        path: "/scorm-report",
        name: "ScormReport",
        component: ScormReport,
      },
      {
        path: "/scorm-report/details/employee/:employee_id/course/:course_id",
        name: "ScormReportDetails",
        component: ScormReportDetails,
      },
      {
        path: "/concord-hospitality-group",
        name: "ConcordHospitalityGroup",
        component: () =>
          import("@/views/Pages/signup-pages/ConcordHospitalityGroup.vue"),
      },
      {
        path: "/locations/:location_id/details",
        name: "details",
        component: () => import("@/views/Pages/signup-pages/Details.vue"),
      },
      {
        path: '/admin/branding',
        name: 'BrandingIndex',
        component: () => import('@/views/admin/branding/Index.vue')
      },
      {
        path: '/admin/branding/create',
        name: 'BrandingCreate',
        component: () => import('@/views/admin/branding/Form.vue')
      },
      {
        path: '/admin/branding/:id/edit',
        name: 'BrandingEdit',
        component: () => import('@/views/admin/branding/Form.vue'),
        props: true
      },

    ],
  },
  bostonLayout,
  authPages,
];

export default routes;
